import React, { useEffect, useState } from "react";

import carData from "../assets/data/carData";
import { Container, Row, Col } from "reactstrap";
import Helmet from "../components/Helmet/Helmet";
import { useParams } from "react-router-dom";
import BookingForm from "../components/UI/BookingForm";
import PaymentMethod from "../components/UI/PaymentMethod";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { addSelectedCar } from "../Features/bookingSlice";
import axiosInstance from "../axiosInstance";
import { constants } from "../Utils/constants";

const CarDetails = () => {
  const { slug } = useParams();
  const dispatch = useDispatch();

  // private String vehicleNo;

  // private String vehicleNo;

  // private String brand;carName
  // private String model;
  // private LocalDate makeYear;
  // private String fuelType;speed
  // private String driveType;automatic
  // private String category;
  // private Integer seatingCapacity;
  // private boolean haveABS;
  // private boolean haveAirBags;
  // private String imageUrl;
  // private Double baseFare;price
  // private Integer tripsCompleted;
  // private Long branchId;
  // private boolean status;
  // private boolean availability;

  //const singleCarItem = carData.find((item) => item.id === parseInt(slug));
  const [singleCarItem, setSingleCarItem] = useState([]);
  useEffect(() => {
    const allCarList = async () => {
      const resp = await axiosInstance.get(constants.serverUrl+`/cars/car/${slug}`);
      console.log(resp.data);
      dispatch(addSelectedCar(resp.data));

      console.log(resp.data);

      setSingleCarItem(resp.data);

      // if(resp.data?.status==false){
      //   toast.error(resp.data?.message, {
      //     theme: "colored",
      //   });
      // }
      // else{
      //  // console.log(resp.data)
      //   setCarData(resp.data);
      //   //console.log(carData);
      // }
    };
    allCarList();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [singleCarItem]);

  return (
    <Helmet title={singleCarItem?.brand}>
      <section>
        <Container>
          <Row>
            <Col lg="6">
              <Row>
                <img src={singleCarItem?.imageUrl} alt="" className="w-100" />
              </Row>
              <Row className="mt-5">
                <div className="car__info">
                  <h2 className="section__title">{singleCarItem?.model}</h2>

                  <div className=" d-flex align-items-center gap-5 mb-4 mt-3">
                    <h6 className="rent__price fw-bold fs-4">
                      ₹{singleCarItem?.baseFare}.00/Hr.
                    </h6>

                    <span className=" d-flex align-items-center gap-2">
                      <span style={{ color: "#f9a826" }}>
                        <i class="ri-star-s-fill"></i>
                        <i class="ri-star-s-fill"></i>
                        <i class="ri-star-s-fill"></i>
                        <i class="ri-star-s-fill"></i>
                        <i class="ri-star-s-fill"></i>
                      </span>
                      ({singleCarItem?.tripsCompleted} tripsCompleted)
                    </span>
                  </div>

                  {/* <p className="section__description">
                    {singleCarItem.seatingCapacity}
                  </p> */}

                  <div
                    className=" d-flex align-items-center mt-3"
                    style={{ columnGap: "2rem" }}
                  >
                    <span className=" d-flex align-items-center gap-1 section__description">
                      <i
                        class="ri-roadster-line"
                        style={{ color: "#f9a826" }}
                      ></i>{" "}
                      {singleCarItem?.model}
                    </span>

                    <span className=" d-flex align-items-center gap-1 section__description">
                      <i
                        class="ri-settings-2-line"
                        style={{ color: "#f9a826" }}
                      ></i>{" "}
                      {singleCarItem?.driveType}
                    </span>

                    <span className=" d-flex align-items-center gap-1 section__description">
                      <i
                        class="ri-timer-flash-line"
                        style={{ color: "#f9a826" }}
                      ></i>{" "}
                      {singleCarItem?.fuelType}
                    </span>

                    <span className=" d-flex align-items-center gap-1 section__description">
                      <i
                        class="ri-wheelchair-line"
                        style={{ color: "#f9a826" }}
                      ></i>{" "}
                      {singleCarItem?.seatingCapacity}
                    </span>
                  </div>

                  <div
                    className=" d-flex align-items-center mt-3"
                    style={{ columnGap: "2.8rem" }}
                  >
                    {/* <span className=" d-flex align-items-center gap-1 section__description">
                      <i
                        class="ri-map-pin-line"
                        style={{ color: "#f9a826" }}
                      ></i>{" "}
                      {singleCarItem.haveABS}
                    </span> */}

                    <span className=" d-flex align-items-center gap-1 section__description">
                      {/* <i
                        class="ri-building-2-line"
                        style={{ color: "#f9a826" }}
                      ></i>{" "} */}
                      Introducing our {singleCarItem?.model} a masterpiece of
                      engineering and design. This {singleCarItem?.category}{" "}
                      offers an exhilarating driving experience with its
                      powerful {singleCarItem?.fuelType} engine and luxurious
                      interior. Whether you're cruising through city streets or
                      embarking on a cross-country adventure, our{" "}
                      {singleCarItem?.model} ensures unmatched comfort,
                      performance, and elegance for your journey.
                    </span>
                  </div>
                </div>
              </Row>
            </Col>
            <Col className="ms-5">
              <Row className="mt-5">
                <div className="booking-info mt-5">
                  <h5 className="mb-4 fw-bold ">Fare Details</h5>
                  <BookingForm />
                </div>
              </Row>
              <Row className="mt-5">
                <div className="payment__info mt-5">
                  <h5 className="mb-4 fw-bold ">Payment Information</h5>
                  <PaymentMethod />
                </div>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default CarDetails;
